import React from 'react';
import logo from '../../images/yak-head.png';

export default class Logo extends React.Component {
  render() {
    return(
      <div className='row'>
        <div className='home-logo'>
          <h1 className='title'>
            <span className='pull-right'>Yak</span><img src={ logo } className="logo" alt="yak tack" /><span className='pull-left'>Tack</span>
          </h1>
          <p className="slogan">
            Improve your vocabulary.
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/logo.jsx